import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { http } from '@frontend/fetch';
import { InsuranceCoverageResponseDental, FeedbackBodyType, EligibilityReportWritebackRequest } from './types';

export const getInsuranceDetails = (
  personId: string,
  locationId: string,
  insuranceType: InsuranceType = InsuranceType.INSURANCE_TYPE_PRIMARY
) =>
  http.post<InsuranceCoverageResponseDental>(
    `/insurance-verification/v1/person/${personId}/dental-coverage-info`,
    {
      insuranceType,
    },
    locationId
      ? {
          headers: { 'Location-Id': locationId },
        }
      : undefined
  );

export const postFeedback = async (body: FeedbackBodyType) =>
  http.post<void>(`insurance-verification/v1/feedback`, body);

export const initiateEligibilityReportWriteback = (
  eligibilityReportWritebackRequest: EligibilityReportWritebackRequest,
  sourceId: string,
  personPMSID: string
) => {
  return http.post<Record<string, never>>(
    `/insurance-verification/v1/${sourceId}/${personPMSID}/insurance-eligibility-report`,
    eligibilityReportWritebackRequest
  );
};
